module.exports = __webpack_public_path__ + "img/intro_min.8980589c.jpg";